import React, { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

export const formatRemaining = (ms) => {
    const s = Math.max(0, Math.floor(ms / 1000));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    return h > 0 ? `${h}:${pad(m)}:${pad(s % 60)}` : `${pad(m)}:${pad(s % 60)}`;
};

export const DiscountCountdown = ({ expiresAt, testid, className = "" }) => {
    const [now, setNow] = useState(Date.now());
    useEffect(() => {
        const t = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(t);
    }, []);
    if (!expiresAt) return null;
    return (
        <span
            data-testid={testid}
            className={`inline-flex items-center gap-1.5 font-mono font-bold tabular-nums ${className}`}
        >
            <Timer className="w-3.5 h-3.5" />
            Expires in {formatRemaining(expiresAt - now)}
        </span>
    );
};
